import { useCallback, useState } from 'react';
import AuthService from 'App/services/AuthService';

const useChangeBranch = () => {
    const [isChanging, setIsChanging] = useState(false);

    const handleChangeBranch = useCallback(async (branchId) => {
        setIsChanging(true);
        try {
            await AuthService.changeBranch(branchId);
            // Do NOT call setUser here if AuthService.changeBranch
            // ultimately updates the JWT + TokenManagerService.
            // The UserContext subscription will handle it.
        } finally {
            setIsChanging(false);
        }
    }, []);

    return {
        handleChangeBranch,
        isChanging,
    };
};

export default useChangeBranch;
